export { DocumentCollectionAndFiling } from './DocumentCollectionAndFiling';
